export const GRADE = 'grade';
export const FILIERE = 'filiere';
export const ECHELON = 'echelon';
export const RAISE_PERCENT = 'raisePercent';
export const START_DATE = 'startDate';
export const RAW_INDEX = 'rawIndex';
export const MAJORED_INDEX = 'majoredIndex';
export const DURATION = 'duration';
export const RAW_SALARY = 'rawSalary';
export const INCREASE_PERCENTAGE = 'increasePercentage';
